import { useEffect, useState } from "react"
import { getAllHomestays } from "../../../../../services/homestayService";

const useGetHomestayisActive = () => {
    const [isActive, setIsActive] = useState([]);
    useEffect(() => {
        const fetchStatus = async () => {
            try {
                const response = await getAllHomestays({isActive: true});
                setIsActive(response)
            } catch (error) {
                setIsActive(false)
            }
        }
        fetchStatus();
    }, [])

    return [isActive]
}

export default useGetHomestayisActive;